import React from 'react'
import { string } from 'prop-types'
import './index.scss'

const SignUpTop = ({ name, type, moduleId }) => {
  const link = () => {
    window.location.href = '/baby-club/join-now'
  }
  return (
    <div
      className="sign-up-top"
      data-module={name}
      data-module-name={name}
      data-module-id={moduleId}
      data-module-type={type}
    >
      <div className="sign-up-top-inner">
        <h2>Join the club</h2>
        <p>
          Get the latest advice and offers from Asda by signing up to our Baby
          &amp; Toddler Club
        </p>
        <button className="btn" onClick={link}>
          Sign up
        </button>
      </div>
    </div>
  )
}

SignUpTop.propTypes = {
  name: string,
  moduleId: string,
  type: string,
}

SignUpTop.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default SignUpTop



// WEBPACK FOOTER //
// ./components/baby-club/sign-up-top/index.js